import { exampleUser, User } from '../user';

export interface ReleaseNote {
  id: number;
  name: string;
  content: string;
  version: number;
  createdAt: number;
  createdBy: User;
  publishedAt: number;
  publishedBy: User;
}

export const exampleReleaseNote: ReleaseNote = {
  id: 1,
  name: 'Ad Builder',
  version: 1,
  content: 'its great',
  createdAt: +new Date(),
  createdBy: exampleUser,
  publishedAt: +new Date(),
  publishedBy: exampleUser,
};
